import { action, createRequestTypes } from '../base';

export const whatsappIntegrationActionTypes = {
  GET_WHATSAPP_CONNECTIONS: createRequestTypes('GET_WHATSAPP_CONNECTIONS'),
  TOGGLE_WHATSAPP: createRequestTypes('TOGGLE_WHATSAPP'),
  UPDATE_WHATSAPP_CONFIGURATION: createRequestTypes('UPDATE_WHATSAPP_CONFIGURATION'),
  SEND_WHATSAPP_NOTIFICATION: createRequestTypes('SEND_WHATSAPP_NOTIFICATION'),
};

class WhatsappIntegrationActions {
  getWhatsappConnections = (orgId, callback) => action(whatsappIntegrationActionTypes.GET_WHATSAPP_CONNECTIONS.REQUEST, {
    orgId, callback,
  })

  /**
   *
   * @param {*} getWhatsappConnectionsLoading
   * @return
   */
    getWhatsappConnectionsLoading = (getWhatsappConnectionsLoading) => action(whatsappIntegrationActionTypes.GET_WHATSAPP_CONNECTIONS.LOADING, {
      getWhatsappConnectionsLoading,
    })

    /**
  * @return
  * @param linkedDaData
  */
     getWhatsappConnectionsSuccess = (whatsappConnections) => action(whatsappIntegrationActionTypes.GET_WHATSAPP_CONNECTIONS.SUCCESS, {
       whatsappConnections,
     })

     /**
 * @param {*} payload
 * @param callback
 * @return
 */
toggleWhatsapp = (payload, callback) => action(whatsappIntegrationActionTypes.TOGGLE_WHATSAPP.REQUEST, {
  payload, callback,
})

/**
 * @param toggleWhatsappLoading
 * @return {{type: *}}
 */
   toggleWhatsappLoading = (toggleWhatsappLoading) => action(whatsappIntegrationActionTypes.TOGGLE_WHATSAPP.LOADING, {
     toggleWhatsappLoading,
   })

   /**
 *
 * @param {*} payload
 * @param {*} callback
 * @returns
 */
updateWhatsappConfiguration = (payload, callback) => action(whatsappIntegrationActionTypes.UPDATE_WHATSAPP_CONFIGURATION.REQUEST, {
  payload, callback,
})

/**
*
* @param {*} updateWhatsappConfigurationLoading
* @returns
*/
updateWhatsappConfigurationLoading = (updateWhatsappConfigurationLoading) => action(whatsappIntegrationActionTypes.UPDATE_WHATSAPP_CONFIGURATION.LOADING, {
  updateWhatsappConfigurationLoading,
})

/**
 * @param {*} payload
 * @param callback
 * @return
 */
sendWhatsappNotification = (payload, entityName, callback) => action(whatsappIntegrationActionTypes.SEND_WHATSAPP_NOTIFICATION.REQUEST, {
  payload, entityName, callback,
})

/**
 * @param sendWhatsappNotificationLoading
 * @return {{type: *}}
 */
   sendWhatsappNotificationLoading = (sendWhatsappNotificationLoading) => action(whatsappIntegrationActionTypes.SEND_WHATSAPP_NOTIFICATION.LOADING, {
     sendWhatsappNotificationLoading,
   })
}

export default new WhatsappIntegrationActions();
